import { render, staticRenderFns } from "./TotalUSCovidTests.vue?vue&type=template&id=e48546f0&"
import script from "./TotalUSCovidTests.vue?vue&type=script&lang=js&"
export * from "./TotalUSCovidTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports